import { service } from '@ember/service'
import Component from '@glimmer/component'
import type PromoService from 'teacher-ui-client/services/promo'
import {
  InlineAlert,
  AlertType,
  InlineAlertTitle,
  InlineAlertSubtitle,
} from 'teacher-ui-client/components/inline-alert'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'

interface Signature {
  Args: {
    isSubco: boolean
  }
}

/**
 * MS CrossSell component, to show on reading eggs home page to notify users of free Mathseeds access
 **/

export class MSFreeAccessCrossSell extends Component<Signature> {
  @service promo!: PromoService

  <template>
    {{! template-lint-disable no-bare-strings }}
    {{#if this.promo.shouldShowMsCrossSell}}
      <InlineAlert @type={{AlertType.Information}}>
        <InlineAlertTitle>
          {{t "promo.crossSell.maths.intro"}}
        </InlineAlertTitle>
        <InlineAlertSubtitle>
          <div class="space-y-2">
            <div>
              {{t "promo.crossSell.maths.about"}}
            </div>
            {{#if @isSubco}}
              <div>
                Your teachers can get started with Mathseeds by
                <LinkTo @route="manage.classes" @model="maths"> setting up a class.</LinkTo>
                As the subscription coordinator, you can
                <LinkTo @route="subscription-type.copy-classes" @model="maths">
                  copy over your school’s reading classes
                </LinkTo>
                to help your teachers get started today.
              </div>
            {{else}}
              <div>
                Get started with Mathseeds by
                <LinkTo @route="manage.classes" @model="maths"> setting up a class.</LinkTo>
                You can
                <LinkTo @route="subscription-type.copy-classes" @model="maths">
                  copy over your reading class
                </LinkTo>
                if you have one.
              </div>
            {{/if}}
          </div>
        </InlineAlertSubtitle>
      </InlineAlert>
    {{/if}}
  </template>
}

export default MSFreeAccessCrossSell
